import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { FileTextIcon, LayoutTemplateIcon, CheckSquareIcon, MessageSquareIcon, CalendarIcon } from 'lucide-react';
const included = [{
  icon: FileTextIcon,
  title: 'Ebook (plan de 7 días)',
  description: 'Guía paso a paso para construir tu avatar desde cero'
}, {
  icon: LayoutTemplateIcon,
  title: 'Plantillas',
  description: 'Ficha de identidad, reglas de estilo, script base'
}, {
  icon: CheckSquareIcon,
  title: 'Checklist anti-cringe',
  description: 'Evita los errores que hacen que tu contenido se sienta falso'
}, {
  icon: MessageSquareIcon,
  title: 'Pack de ganchos',
  description: 'Alta intención, sin sonar vendedor'
}, {
  icon: CalendarIcon,
  title: 'Calendario 14 días',
  description: 'Para sostener consistencia sin quemarte'
}];
export function IncludedSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4 bg-black/30" data-id="element-88">
      <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 50
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-89">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-90">
          Lo que incluye{' '}
          <span className="text-cyan-400" data-id="element-91">"Avatar Digital Rentable"</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-92">
          {included.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-zinc-900/50 border border-cyan-500/20 rounded-lg p-6" data-id="element-93">
                <Icon className="w-10 h-10 text-cyan-400 mb-4" aria-hidden="true" data-id="element-94" />
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-95">
                  {item.title}
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-96">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>
      </motion.div>
    </section>;
}